import { arrayOf, exact, number, oneOfType } from 'prop-types';

export const PointArrayType = arrayOf(number);

export const PointShapeType = exact({
  lat: number.isRequired,
  lng: number.isRequired,
});

export const LatLngType = oneOfType([PointArrayType, PointShapeType]);
